import {motion as m} from 'framer-motion';
import ScrollToTop from '../../components/ScrollToTop';
import {useEffect} from 'react';
import PageHeaderImage from '../../images/pageheader.jpg';
import PageHeader from '../../components/PageHeader';
import {Link} from 'react-router-dom';
import SafeImage from '../../images//homepage-header/Vallan-pest-control.png';
// import HomeServices from '../../components/HomeServices';
import WhyUs from '../../components/WhyUs';
import ContactCta from '../../components/ContactCta';
import FAQS from '../../components/FAQS';
import './birdControl.css';

const BirdControl = () => {
    return (
        <m.div 
            initial={{x: "-100%"}}
            animate={{x: "-0%"}}
            transition={{ duration: 0.9, delay:0.7}}
            exit={{opacity: 1}}
        >
            <ScrollToTop />
            <PageHeader title="Bird Control" image={PageHeaderImage}>
                <p>
                    <Link to="/">Home</Link> / <Link to="/services">Services</Link> / Bird Control
                </p>
            </PageHeader>
            <section className='services'>

                <div className="bird-control-container container">
                    <div className="bird-control-content-container">
                        <div className="bird-control-content">
                            <h1>
                                Bird Control
                            </h1>
                            <br />
                            <p>
                                Welcome to PestEX Masters, your trusted partner in pest control solutions in Kenya. We understand
                                that birds can sometimes pose challenges when they invade your property. That&#39;s why we offer
                                comprehensive and effective bird control services tailored to your specific needs.
                            </p>
                            <p>
                                Bird infestations can cause significant damage to your property, compromise hygiene standards, and
                                create a nuisance for residents or employees. Our team of experienced professionals at PestEX Masters
                                is equipped with the knowledge and tools to efficiently address your bird control concerns, ensuring a
                                bird-free environment for you.
                            </p>
                            <h2>Bird control services we provide:</h2>
                            <br />
                            <p>
                                <b>Bird Removal:</b>Our experts will assess the extent of the bird infestation and develop a customized plan to
                                safely remove the birds from your property. We employ humane and effective methods, ensuring the
                                welfare of the birds while restoring the safety and cleanliness of your premises.
                            </p>
                            <p>
                                <b>Bird Deterrents:</b>Preventing birds from roosting or nesting on your property is crucial to avoid recurring
                                infestations. We install a range of bird deterrent systems, including bird spikes, netting, and wire
                                barriers. These solutions effectively discourage birds from landing or perching, preventing damage to
                                structures and minimizing health hazards.
                            </p>
                            <p>
                                <b>Bird Exclusion:</b>To eliminate the entry points that birds use to access your property, we identify and seal
                                off any openings, gaps, or cracks. By implementing effective bird exclusion measures, we create a bird-
                                proof environment, preventing further intrusions and minimizing the need for ongoing bird control
                                efforts.
                            </p>
                            <p>
                                <b>Bird Waste Cleanup:</b>Bird droppings not only deface buildings but can also be a health hazard. Our team
                                specializes in safe and thorough bird waste cleanup, ensuring the removal of all droppings and sanitizing
                                affected areas. We utilize eco-friendly disinfectants to maintain a clean and hygienic environment.
                            </p>
                            <p>
                                <b>Customized Solutions:</b>At PestEX Masters, we understand that every bird control situation is unique. Our
                                experienced professionals will work closely with you to develop a tailored solution that suits your
                                specific needs and requirements. We take into account factors such as the type of bird species, the
                                location of your property, and the extent of the infestation, ensuring the most effective and sustainable
                                outcome.
                            </p>
                            <p>
                                Choose PestEX Masters for comprehensive bird control services in Kenya. Our commitment to quality,
                                reliability, and customer satisfaction sets us apart from the rest. With our expertise and industry-leading
                                techniques, you can trust us to deliver outstanding results and restore the harmony to your property.
                            </p>
                            <p>
                                Contact PestEX Masters today to schedule a consultation and take the first step toward a bird-free
                                environment. Don&#39;t let unwanted birds disrupt your peace of mind any longer – let us handle your bird
                                control needs with precision and professionalism.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container bird-control-saftey-cont">
                    <div className='saftey'>
                        <div className="container saftey_container">
                            <div className="saftey_header">
                                <h1>We use safe and environmentally friendly measures.</h1>
                                <p>Want to create a pest-free environment without compromising your commitment to sustainability? Our environmentally friendly pest control products are the solution.</p>
                            </div>
                            <div className="saftery_image">
                                <img src={SafeImage} alt="" />
                            </div>
                        </div>
                    </div>
                    {/* <HomeServices /> */}
                    <WhyUs />
                    <ContactCta />
                    <FAQS />
                </div>
            </section>
        </m.div>
    )
}

export default BirdControl